import { render, staticRenderFns } from "./Territory.vue?vue&type=template&id=2aec2e87"
import script from "./Territory.vue?vue&type=script&lang=js"
export * from "./Territory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports